<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <user-group />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import UserGroup from "./components/UserGroup";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    UserGroup,
    // ProjectsTable,
  },
};
</script>
